import React, { useState } from 'react';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Container, Typography } from '@mui/material';
import Header from '../Header';
import AdminNav from './AdminNav';
import { useAuth } from '../../context/AuthContext';
import { ApiError } from '../../services/online/apiClient';

export default function AdminRankingsScreen() {
    const { authFetch } = useAuth();
    const [isRunning, setIsRunning] = useState(false);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);

    const handleRecompute = async () => {
        if (!window.confirm('¿Recalcular todos los rankings ahora? Esto puede tardar varios segundos.')) return;
        setIsRunning(true);
        setError(null);
        setDone(false);
        try {
            await authFetch('/admin/rankings/recompute', { method: 'POST' });
            setDone(true);
        } catch (err) {
            setError(err instanceof ApiError ? err.message : 'No se pudo recalcular los rankings.');
        } finally {
            setIsRunning(false);
        }
    };

    return (
        <>
            <Header title="Rankings" showSettings={false} />
            <AdminNav />
            <Container maxWidth="sm" sx={{ mt: 3, mb: 4 }}>
                <Card elevation={2}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>Recálculo manual</Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Los rankings se recalculan automáticamente cada noche. Este botón fuerza un recálculo
                            inmediato de todos los periodos y modalidades — útil tras corregir datos o para
                            comprobar un cambio sin esperar al job nocturno.
                        </Typography>
                        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                        {done && <Alert severity="success" sx={{ mb: 2 }}>Rankings recalculados correctamente.</Alert>}
                        <Button variant="contained" disabled={isRunning} onClick={handleRecompute}>
                            {isRunning ? <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><CircularProgress size={18} color="inherit" /> Recalculando…</Box> : 'Recalcular ahora'}
                        </Button>
                    </CardContent>
                </Card>
            </Container>
        </>
    );
}
